export default __webpack_public_path__ + "3f5c065017e3e6d2f8b4d5808e8b2ef8.png";